<nz-form-item class="label-on-top">
  <nz-form-label *ngIf="label" [nzRequired]="isRequired(control)">
    {{ label }}
  </nz-form-label>
  <nz-form-control nzHasFeedback [nzErrorTip]="errorTemplate" [nzValidateStatus]="control">
    <nz-tree-select
      style="width: 100%"
      [nzPlaceHolder]="placeholder"
      [nzExpandedKeys]="expandKeys"
      [formControl]="control"
      [nzDropdownMatchSelectWidth]="true"
      [nzDropdownStyle]="{ 'max-height': '300px' }"
      [nzNodes]="nodes"
      [nzDisabled]="isDisabled"
      [nzSize]="size"
      nzShowSearch
      nzCheckable
    >
    </nz-tree-select>
  </nz-form-control>
  <ng-template #errorTemplate>
    {{ control.errors | formError }}
  </ng-template>
</nz-form-item>
